import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { api, mediaUrl } from "@/lib/api";
import { useSite, setSeo } from "@/context/SiteContext";
import { Prose } from "@/components/common";

export function CustomPage({ notFound }) {
  const { slug } = useParams();
  const { settings } = useSite();
  const [page, setPage] = useState(null);
  const [missing, setMissing] = useState(!!notFound);
  useEffect(() => {
    if (notFound) return;
    api.get(`/pages/${slug}`).then((r) => {
      setPage(r.data);
      setSeo(r.data.seo_title || `${r.data.title} | ${settings.brand.site_name}`, r.data.seo_description);
    }).catch(() => setMissing(true));
    return () => setSeo(settings.seo.title, settings.seo.description);
  }, [slug, notFound, settings]);
  if (missing)
    return (
      <div className="container-bt py-24 text-center" data-testid="not-found-page">
        <h1 className="text-5xl">Page not found</h1>
        <Link to="/" className="btn-primary mt-8">Go home</Link>
      </div>
    );
  if (!page) return <div className="min-h-[60vh]" />;
  return (
    <article className="container-bt py-14 sm:py-20" data-testid="custom-page">
      <div className="mx-auto max-w-3xl">
        <h1 className="mb-10 text-4xl sm:text-5xl">{page.title}</h1>
        {page.image && <img src={mediaUrl(page.image)} alt="" className="mb-10 w-full rounded-[32px] object-cover" />}
        <Prose text={page.body} />
      </div>
    </article>
  );
}

export function Unsubscribe() {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");
  useEffect(() => {
    api.get("/unsubscribe", { params: { token: params.get("token") } }).then(() => setState("done")).catch(() => setState("error"));
  }, [params]);
  return (
    <div className="container-bt py-24 text-center" data-testid="unsubscribe-page">
      <h1 className="text-4xl">{state === "done" ? "You've been unsubscribed." : state === "error" ? "That link didn't work." : "One moment..."}</h1>
      {state === "done" && <p className="mt-4">We're sorry to see you go. The free resources are always here for you.</p>}
      <Link to="/free" className="btn-primary mt-8">Free Growth Hub</Link>
    </div>
  );
}

export function RemindersOff({ daily }) {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");
  useEffect(() => {
    api.get(daily ? "/daily-emails/off" : "/reminders/off", { params: { token: params.get("token") } }).then(() => setState("done")).catch(() => setState("error"));
  }, [params, daily]);
  return (
    <div className="container-bt py-24 text-center" data-testid="reminders-off-page">
      <h1 className="text-4xl">{state === "done" ? (daily ? "Daily affirmation emails turned off." : "Challenge reminders turned off.") : state === "error" ? "That link didn't work." : "One moment..."}</h1>
      {state === "done" && <p className="mt-4">{daily ? "You'll still find a new affirmation on your dashboard every day." : "Your progress is saved. Pick it up whenever you're ready."}</p>}
      <Link to="/account" className="btn-primary mt-8">My account</Link>
    </div>
  );
}
